<script lang="ts" setup>
import { ref, watch, defineEmits, defineProps } from 'vue'
import { VueDraggable } from 'vue-draggable-plus'
import type { Opportunity } from '@/api-swagger'
import OpportunityCard from '@/components/features/opportunities/OpportunityCard.vue'
import { useOpportunityStore } from '@/stores/useOpportunityStore'
import { storeToRefs } from 'pinia'
import OpportunityEdit from '@/components/features/opportunities/OpportunityEdit.vue'

const props = defineProps<{
  listOpportunity: Opportunity[]
  stageId: number
}>()

const opportunityStore = useOpportunityStore()
const { selectedOpportunity } = storeToRefs(opportunityStore)

const showModal = ref(false)

const openModal = (opportunity: Opportunity) => {
  opportunityStore.setSelectedOpportunity(opportunity)
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  opportunityStore.setSelectedOpportunity(null)
}

const emit = defineEmits(['end'])

const list = ref([...props.listOpportunity])

watch(
  () => props.listOpportunity,
  (newList) => {
    list.value = [...newList]
  },
  { deep: true },
)

function onEndDrag(event: any) {
  const opportunityId = event.data.id

  const newStageId = Number(event.to.closest('[data-stage-id]')?.getAttribute('data-stage-id'))

  if (opportunityId && newStageId && props.stageId !== newStageId) {
    emit('end', { opportunityId, newStageId })
  }
}
</script>

<template>
  <div class="flex m-1 h-full">
    <VueDraggable
      class="w-full"
      :scroll="true"
      :scroll-sensitivity="200"
      :force-fallback="true"
      v-model="list"
      :group="'name'"
      :order="true"
      @end="onEndDrag"
      :filter="'.no-drag'"
    >
      <div class="m-3" v-for="element in list" :key="element.id">
        <OpportunityCard :opportunity="element" @openModal="openModal" />
      </div>
    </VueDraggable>
  </div>
  <OpportunityEdit
    v-if="showModal"
    :opportunity="selectedOpportunity!"
    :showModal="showModal"
    @close="closeModal"
  />
</template>
